<dialog-header
  title="Pending Rewards"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
    min-height: 400px;
    max-height: 600px;
  "
>
  <div *ngIf="!loading">
    <ngx-datatable
      #myTable
      class="material"
      [headerHeight]="45"
      [rows]="pendingRewards"
      [scrollbarV]="false"
      [messages]="{ emptyMessage: emptyString }"
      [scrollbarH]="true"
      [footerHeight]="50"
      [columnMode]="'force'"
      [rowHeight]="60"
      [externalPaging]="true"
      [count]="length"
      [offset]="pageIndex"
      (page)="pageEvent($event)"
      (scroll)="handleScroll()"
      [limit]="pageSize"
    >
      <ngx-datatable-column name="Email" [resizeable]="true" [width]="200">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="font-weight: 500">{{ row?.email }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Reward" [resizeable]="true" [width]="200">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="font-weight: 500">{{ row?.reward?.title }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Type" [resizeable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div id="status-chip" [ngClass]="constants.statusChipClass(row)">
            {{ getGiftedByText(row) }}
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Date" [resizeable]="true" [width]="120">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="font-size: 12px">
            {{ formatDate(row?.createdAt) }}
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- <ngx-datatable-column
        name="Actions"
        [resizeable]="false"
        [width]="100"
        [canAutoResize]="false"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <button
            mat-button
            color="warn"
            style="font-size: 12px; padding: 4px 8px; min-width: auto"
            (click)="revertPendingReward(row)"
            [disabled]="loading"
          >
            Revert
          </button>
        </ng-template>
      </ngx-datatable-column> -->
    </ngx-datatable>
  </div>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    [title]="'Close'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>
</div>

<loader [loading]="loading"></loader>
